import { Component, HostListener, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ROUTESPATH } from '@core';
import { ModalService, TokenService, AuthService } from '@services';
import { passwordConfirm } from '@shared/validator/password-confirm.validator';
import { password } from '@shared/validator/password.validator';

@Component({
  selector: 'app-modal-password',
  templateUrl: './modal-password.component.html',
  styleUrls: ['./modal-password.component.scss'],
})
export class ModalPasswordComponent implements OnInit {
  public passwordForm: FormGroup;
  isOpen = false;
  isValid = false;
  public newPasswordOnFocus = false;
  @Input() name: string = 'modal-password';
  validLength;
  validNumber;
  validUppercase;
  validSpecial;
  validPassword;
  passMessage = '';
  public activatedChangePassword: boolean = false;

  public height: number = window.innerHeight;
  @HostListener('window:resize')
  onResize() {
    this.height = window.innerHeight;
  }

  constructor(
    private modalService: ModalService,
    private formBuilder: FormBuilder,
    private auth: AuthService,
    private router: Router,
    private readonly tokenService: TokenService
  ) {}

  ngOnInit(): void {
    this.modalService.change.subscribe((modal) => {
      if (modal && modal.name === this.name) {
        this.isOpen = modal.isOpen;
      }
    });
    this.modalService.register(this.name);
    this.passwordForm = this.formBuilder.group({
      oldPassword: ['', [Validators.required]],
      newPassword: [
        '',
        [
          Validators.required,
          password,
          passwordConfirm('repeatPassword', true),
        ],
      ],
      repeatPassword: [
        '',
        [Validators.required, password, passwordConfirm('newPassword')],
      ],
    });
    this.activatedChangePassword = TokenService.user.changePassword;
  }

  checkValid(): void {
    const newPassword = this.passwordForm.controls['newPassword'].value;
    const repeatPassword = this.passwordForm.controls['repeatPassword'].value;

    newPassword.length >= 8
      ? (this.validLength = true)
      : (this.validLength = false);

    /\d/.test(newPassword)
      ? (this.validNumber = true)
      : (this.validNumber = false);

    /[A-Z]/.test(newPassword)
      ? (this.validUppercase = true)
      : (this.validUppercase = false);

    /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(newPassword)
      ? (this.validSpecial = true)
      : (this.validSpecial = false);

    this.validPassword =
      this.validLength &&
      this.validNumber &&
      this.validUppercase &&
      this.validSpecial;
    if (!this.validPassword) this.passMessage = 'Inválida';
    else if (repeatPassword === '') {
      this.passMessage = 'Ingresar Repetir contraseña';
      this.validPassword = false;
    } else if (repeatPassword !== newPassword) {
      this.passMessage = 'Contraseñas distintas';
      this.validPassword = false;
    } else this.passMessage = 'Válida';
  }

  async save() {
    if (this.passwordForm.valid) {
      const { oldPassword, newPassword, repeatPassword } =
        this.passwordForm.value;
      if (newPassword === repeatPassword) {
        const response = await this.auth.changePassword({
          oldPassword,
          newPassword,
        });
        if (response) {
          this.isValid = true;
        }
      }
    }
  }

  next() {
    this.modalService.close('modalPassword');
    this.tokenService.resetToken();
    this.router.navigate([ROUTESPATH.LOGIN]);
  }

  reInit() {
    this.passwordForm.reset();
    this.validPassword = undefined;
  }
}
